<div [formGroup]="ui.bookForm">
  <div formArrayName="texts">
    <div *ngFor="let text of textsControl.controls; let i = index" [formGroupName]="i">
      <div class="md:flex mb-6">
        <div class="xl:w-96 lg:w-80 md:w-64">
          <label class="block text-gray-500 md:mt-2 font-bold md:text-left mb-1 md:mb-0 pr-4 text-xl" for="inline-full-name">
            Trích đoạn {{i + 1}} (
            <button (click)="deleteTextControl(i)">
              <fa-icon class=" mx-1 text-red-500" [icon]="faIcon"></fa-icon></button>
            )
          </label>
        </div>
        <div class="md:w-full">
          <textarea cols="30" rows="10" [formControl]="$any(text)"
            class="scroll resize-none rounded-lg border border-solid border-gray-400 outline-none w-full py-2 px-4 focus:outline-none focus:border-primary"
            [placeholder]="'Trích đoạn' + ' ' + (i + 1) + ' ' + 'nên trong giới hạn khoảng 500 ký tự'">
          </textarea>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="w-full mb-6">
  <button (click)="addTextControl()" class="border border-primary text-primary bg-white w-full py-1.5  font-bold rounded-md hover:text-white hover:bg-primary">
    Thêm trích đoạn
  </button>
</div>